import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
@Component({
  selector: 'file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {

  @Input() MaxFileCount:number = 1000;
  public uploader: FileUploader = new FileUploader({
    url: ''
  });

  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
  constructor() { }

  ngOnInit() {
    
  }
  update(_prodId: string, _uploader:FileUploader) {
    this.uploader = _uploader;
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      form.append("productId", _prodId);
    };
    this.uploader.onCompleteAll = () => {
      alert("All files uploaded, Click Ok to clear the form");
      this.uploader.clearQueue();
    };
  }

  updateDraw(_prodId: string,_soId: string, _subId: string, _uploader:FileUploader) {
    this.uploader = _uploader;
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      form.append("productId", _prodId);
      form.append("soId", _soId);
      form.append("subId", _subId);
    };
    this.uploader.onCompleteAll = () => {
      alert("All files uploaded, Click Ok to clear the form");
      this.uploader.clearQueue();
    };
  }

  clearForm(){
    this.uploader.clearQueue();
  }

  updateDefFile(_uploader:FileUploader){
    this.uploader = _uploader;
    this.uploader.clearQueue();
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
    };

    console.log(this.uploader);
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

}


